// extracted by mini-css-extract-plugin
module.exports = {"cursorWrapper":"CustomCursor_cursorWrapper__7vhI7","customCursor":"CustomCursor_customCursor__yfKdx"};